export default () => ({
  map: null,
  interactions: {},
  basemaps: null,
  activeBasemap: "basis"
});
